import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

// @ts-expect-error
import { LostPassword } from '@printdeal/authentication-component';
import { Alert, Button } from '@printdeal/ui-library';
import { getLanguageFromLocale } from '../../../helpers/translations';
import {
  dispatchDataLayerEventOnLostPasswordRequest,
} from '../../../helpers/dataLayerHelpers/LoginDataLayerHelper';
import { getFromLocalStorage, LS_KEYS } from '../../../helpers/window';

interface ModelContentLostPasswordProps {
  setModalView: (key: string) => void;
}

const STATUS = {
  ERROR: 'error',
  INITIAL: 'initial',
  SUCCESS: 'success',
};

const ModelContentLostPassword = ({ setModalView }: ModelContentLostPasswordProps) => {
  const intl = useIntl();
  const [status, setStatus] = useState(STATUS.INITIAL);
  const authToken = getFromLocalStorage(LS_KEYS.AUTH_TOKEN);

  const handleLostPasswordCallback = (_err: any, res: { success: boolean }) => {
    dispatchDataLayerEventOnLostPasswordRequest();

    if (res && res.success) {
      return setStatus(STATUS.SUCCESS);
    }
    return setStatus(STATUS.ERROR);
  };

  return (
    <div className="pd-flex pd-flex-col pd-gap-3">
      {status === STATUS.ERROR && (
        <Alert variant="error" autoDismiss={10000}>
          <FormattedMessage id="account.lostpassword.error" defaultMessage="Password request failed" />
        </Alert>
      )}
      {status === STATUS.SUCCESS && (
        <Alert variant="success" autoDismiss={10000}>
          <FormattedMessage id="account.lostpassword.success" defaultMessage="Password request successful" />
        </Alert>
      )}
      <FormattedMessage
        id="account.lostpassword.description"
        defaultMessage="Enter your email to request your account details."
      />
      <LostPassword
        store={process.env.GATSBY_STORE}
        channel={process.env.GATSBY_CHANNEL}
        locale={getLanguageFromLocale(intl.locale)}
        callback={handleLostPasswordCallback}
        endpoint={`${process.env.GATSBY_AUTH_ENDPOINT}/getPasswordResetToken`}
        authToken={authToken}
      />
      <Button
        variant="secondary"
        type="button"
        iconBefore="chevron-left"
        onClick={() => setModalView('login')}
        className="pd-w-full"
      >
        <FormattedMessage
          id="account.lostpassword.backToLogin"
          defaultMessage="Back to Login"
        />
      </Button>
    </div>
  );
};

export default ModelContentLostPassword;
